import _regeneratorRuntime from "@babel/runtime/regenerator";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from "react";
import { IntelligentTreeSelect } from "intelligent-tree-select";
import _ from "lodash";
import "intelligent-tree-select/lib/styles.css";
import Tree from "../../objects/tree";
import ReactTreeSelectFieldOption from "./option";

var ReactTreeSelectField = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ReactTreeSelectField, _Component);

  function ReactTreeSelectField(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "handleFetchChildren", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(args) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", _this.tree.getChildOptions(args.option));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (valueOptions) {
      var isMulti = _.get(_this.props, "uiSchema.ui:options.isMulti", false);

      if (!isMulti) {
        var value = _.get(valueOptions, "value");

        _this.props.onChange(value ? [value] : []);
      } else {
        var _value = valueOptions.map(function (option) {
          return option.value;
        });

        _this.props.onChange(_value);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleInputChange", function () {});

    _this.select = React.createRef();
    _this.state = _extends({}, props, {
      width: props.uiSchema["ui:options"] && props.uiSchema["ui:options"].width || 400,
      height: props.uiSchema["ui:options"] && props.uiSchema["ui:options"].height || 150,
      value: props.formData || ""
    });
    var remoteOptions = _.get(props, "uiSchema.ui:options.remote.data") || [];
    _this.tree = new Tree(remoteOptions, _this.select);
    return _this;
  }

  var _proto = ReactTreeSelectField.prototype;

  _proto.getOptionsFromValue = function getOptionsFromValue(value) {
    var currentSelect = this.select.current;

    if (currentSelect) {
      var options = currentSelect.state.options;
      var selectedOptions = (options || []).filter(function (option) {
        return (value || []).some(function (term) {
          return term === option.value;
        });
      });
      return selectedOptions;
    }
  };

  _proto.isRemote = function isRemote() {
    var remoteOptions = _.get(this.props, "uiSchema.ui:options.remote.data") || [];
    return remoteOptions.length > 0;
  };

  _proto.getSchemaOptions = function getSchemaOptions() {
    var uiSchema = this.props.uiSchema;

    if (this.isRemote()) {
      return _.get(uiSchema["ui:options"], "treeOptions");
    } else {
      return _.map(_.get(uiSchema["ui:options"], "treeOptions"), function (opt) {
        if (opt.children.length === 0) {
          opt.isEnd = true;
        }

        return opt;
      });
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        schema = _this$props.schema,
        formData = _this$props.formData;

    var isMulti = _.get(this.props, "uiSchema.ui:options.isMulti", false);

    var isCreateable = _.get(this.props, "uiSchema.ui:options.isCreateable", false);

    var schemaOptions = this.getSchemaOptions();
    var valueOptions = this.getOptionsFromValue(formData, schemaOptions);
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, schema.title), /*#__PURE__*/React.createElement(IntelligentTreeSelect, {
      optionRenderer: function optionRenderer(optionProps) {
        return /*#__PURE__*/React.createElement(ReactTreeSelectFieldOption, _extends({}, optionProps, {
          select: _this2.select
        }));
      },
      ref: function ref(select) {
        _this2.select.current = select;
      },
      showSettings: isCreateable,
      multi: isMulti,
      options: schemaOptions || [],
      value: isMulti ? valueOptions : _.get(valueOptions, "0"),
      fetchOptions: this.handleFetchChildren,
      onChange: this.handleChange,
      onInputChange: this.handleInputChange
    }));
  };

  return ReactTreeSelectField;
}(Component);

export default ReactTreeSelectField;